import React from "react";
import {paramSettingsService} from "../jwt/_services/hotel/paramsSettingsService";

let cache = {};

export const paramSettingsProvider = {
    getOptions,
    getItem,
};

async function getOptions(customFilter) {
    const filterKey = 'ParamSetings:' + JSON.stringify(customFilter);
    const cachedResult = cache[filterKey];

    // Check if result is in cache and is less than 1 hour old
    if (cachedResult && (Date.now() - cachedResult.date) < 3600000) {
        return cachedResult.data;
    }

    try {
        const listItems = await paramSettingsService.search(0, 1000, customFilter);
        const paramSettingValue = listItems?.data[0]?.ps_value_max;
        if (!paramSettingValue) {
            return [];
        }

        const options = paramSettingValue.split('|');

        const result = options.map((option) => {
            return (
                {
                    id: option,
                    value: option,
                    label: <div><label>{ option }</label></div>
                }
            );
        });

        // Store result in cache
        cache[filterKey] = {
            date: Date.now(),
            data: result
        };

        return result;
    } catch (error) {
        console.log(error.message);
    }
}

async function getItem(id) {
    try {
        const item = await paramSettingsService.getItem(id);

        return (
            {
                id: item.id,
                value: item.cogPassSfContact,
                label: <div><label>{item.cogPassSfContact}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}